import './Checkbox.css';
import React from 'react';
import { get } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import addQueryString, { removeQueryString } from './index';
import { useLocation, useHistory } from 'react-router-dom';
import { qsToObject } from '../../utils/querystring';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
const Checkbox = _ref => {
  let {
    fields,
    setFilter,
    clearAlllFilters,
    facetsName,
    analytics,
    getFilterValue,
    columnsClass = 'col-md-3'
  } = _ref;
  const location = useLocation();
  const queryParams = qsToObject(location.search);
  const label = get(fields, 'title.jss.value');
  const filterName = get(fields, 'name');
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  let history = useHistory();
  const checkboxes = /*#__PURE__*/React.createRef();
  let selectedQuery = queryParams.free;
  if (selectedQuery === 'true') {
    selectedQuery = true;
  } else {
    selectedQuery = false;
  }
  React.useEffect(() => {
    if (clearAlllFilters) {
      checkboxes.current.checked = false;
      removeQueryString(facetsName, history);
      getFilterValue && getFilterValue(fields.name, facetsName, null);
    }
  }, [clearAlllFilters]);
  const changeCheckbox = checked => {
    tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), `${filterName} : ${checked ? 'Select' : 'Deselect'}`);
    setFilter();
    if (checked) {
      addQueryString(facetsName, `true`, history);
      getFilterValue && getFilterValue(fields.name, facetsName, 'true');
    } else {
      checkboxes.current.checked = false;
      removeQueryString(facetsName, history);
      getFilterValue && getFilterValue(fields.name, facetsName, null);
    }
  };
  React.useEffect(() => {
    return () => {
      removeQueryString(facetsName, history);
    };
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    columnsClass: columnsClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field checkbox"
  }, /*#__PURE__*/React.createElement("div", {
    className: "switch__field"
  }, /*#__PURE__*/React.createElement("span", {
    className: "body-small switch__text"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "switch"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "switch-2",
    title: label,
    "aria-label": label
  }, /*#__PURE__*/React.createElement("input", {
    defaultChecked: selectedQuery,
    className: "fp__checkbox",
    type: "checkbox",
    value: "true",
    onChange: e => {
      changeCheckbox(e.target.checked);
    },
    onKeyPress: e => {
      if (e.which === 13) {
        e.preventDefault();
        changeCheckbox(!e.target.checked);
        e.target.checked = !e.target.checked;
      }
    },
    ref: checkboxes,
    id: "switch-2",
    title: label,
    "aria-label": label
  }), /*#__PURE__*/React.createElement("div", {
    className: "switch__shape"
  }))))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    columnsClass
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${columnsClass}`
  }, children);
};
export default Checkbox;
const commonStyles = "c1h21nho";
const ltrStyles = "lc7sg1k";
const rtlStyles = "r1c5lur4";